<template>
  <div class="limit-text-wrapper" :class="wrapperClassName">
    <textarea v-if="multiline"
              v-model="text"
              class="limit-text-input"
              :id="id"
              :class="className"
              :cols="cols"
              :rows="rows"
              :placeholder="placeholder"
              @change="onChange"
    ></textarea>
    <input v-else
           v-model="text"
           type="text"
           class="limit-text-input"
           :id="id"
           :class="className"
           :placeholder="placeholder"
           @change="onChange"
    />
    <p class="limit-text-input-counter font-weight-light text-right text-secondary"
       :class="counterClassNames"
       title="Remaining charecters count"
    >{{remainingCount}}</p>
  </div>
</template>

<script>
  export default {
    name: 'LimitTextInput'
  , props: {
      id: String
    , value           : null
    , className       : { type: String, default: '' }
    , wrapperClassName: { type: String, default: '' }
    , counterClassName: { type: String, default: 'text-small' }
    , placeholder     : { type: String, default: '' }
    , required        : Boolean
    , multiline       : { type: Boolean, default: false }
    , limitHigh       : { type: Number, default: 0 }
    , limitLow        : { type: Number, default: 0 }
    , cols            : { type: Number, default: 40 }
    , rows            : { type: Number, default: 5 }
    }
  , data () {
      return {
        text: ''
      }
    }
  , computed: {
      remainingCount () {
        // this.limitHigh - this.text.replace(/\s+/g,'')
        // return (this.limitHigh - this.text.length)
        const length = this.text.length
        const count = (length - this.limitLow)
        return 0 < this.limitLow && 0 > count
              ? `${-count} more needed`
              : ( 0 < this.limitHigh
                ? ( 0 < this.limitHigh - length
                  ? `${this.limitHigh - length} remaining`
                  : `${length - this.limitHigh} over limit`
                  )
                : ''
                )
      }
    // , requiredCount () {
    //     const count = (this.text.length - this.limitLow)
    //     return 0 < this.limitLow && 0 > count ? count : ''
    //   }
    // , hasError () {
    //     return 0 < this.limitLow  && 0 > (this.text.length - this.limitLow)
    //         || 0 < this.limitHigh && 0 > (this.limitHigh - this.text.length)
    //   }
    , counterClassNames () {
        return this.counterClassName.split(/\s+/)
               .concat(this.hasAnyError() ? ['text-danger'] : [])
      }
    // , hasErrorLow () {
    //     return 0 < this.limitLow && 0 > (this.text.length - this.limitLow)
    //   }
    // , hasErrorHigh () {
    //     return 0 > (this.limitHigh - this.text.length)
    //   }
    }
  , methods: {
      hasAnyError () {
        return 0 < this.limitLow  && 0 > (this.text.length - this.limitLow)
            || 0 < this.limitHigh && 0 > (this.limitHigh - this.text.length)
      }
    , onChange () {
        this.$emit('input', this.text)
      }
    }
  }
</script>

<style scoped>
  .limit-text-wrapper {
    width: auto;
  }
  .limit-text-wrapper .limit-text-input {
    width: 100%;
  }
  .limit-text-wrapper input.limit-text-input {
  }
  .limit-text-wrapper textarea.limit-text-input {
  }
  .limit-text-wrapper .limit-text-input-counter {
    margin-bottom: 0px;
    font-size: 0.8em;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/caster/LimitTextInput.vue